export default __webpack_public_path__ + "static/IN-5905HD_Heater-Installation-776d1a68c5795224e29afd234b80460d.png";